import * as React from 'react';

import * as styles from './styles.css';

interface ICardSectionPaperProps {
  id?: string;
  children: React.ReactNode;
  redesign?: boolean;
}

export function CardSection({ children, id }: ICardSectionPaperProps) {
  return (
    <div className={styles['section']} id={id}>
      {children}
    </div>
  );
}
